import Axios from 'axios';
import { store } from '../../node_modules/@bmp-vue/core/plugins/store';
import { FormatURLParams } from '../utils/axiosUtils';
import util from '@bmp-vue/core/api/util';
import ui from '@bmp-vue/core/api/ui';

const getToken = () => JSON.parse(localStorage.getItem('user'))?.token;

const getFileNameFromDisposition = (disposition, fallback) => {
  if (!disposition || !disposition.includes('filename=')) {
    return fallback;
  }

  const matches = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/.exec(disposition);
  return matches?.[1]?.replace(/['"]/g, '') || fallback;
};

const ensureExtension = (fileName, extension) => {
  if (!extension || fileName.endsWith(extension)) {
    return fileName;
  }

  return `${fileName}${extension}`;
};

const triggerBrowserDownload = (data, fileName, contentType) => {
  const blob = new Blob([data], { type: contentType });
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement('a');

  link.href = url;
  link.setAttribute('download', fileName);
  document.body.appendChild(link);
  link.click();
  link.remove();

  window.URL.revokeObjectURL(url);
};

const handleDownloadError = error => {
  ui.HideLoading();
  store.commit('removeRequest');
  throw error;
};

const downloadFile = async (controller, params, { defaultFileName, extension, contentType }) => {
  try {
    const url = process.env.VUE_APP_ROOT_API + controller;
    const response = await Axios.get(url, {
      params: params ? FormatURLParams(params) : {},
      headers: {
        authorization: `Bearer ${getToken()}`
      },
      responseType: 'blob'
    });

    let fileName = getFileNameFromDisposition(
      response.headers['content-disposition'],
      defaultFileName
    );

    fileName = ensureExtension(fileName, extension);

    triggerBrowserDownload(response.data, fileName, contentType);

    ui.HideLoading();
    store.commit('removeRequest');
  } catch (error) {
    handleDownloadError(error);
  }
};

const axios = {
  ...util.Axios,

  DownloadExcelFile(controller, params, fileName = 'arquivo.xlsx') {
    return downloadFile(controller, params, {
      defaultFileName: fileName,
      extension: '.xlsx',
      contentType: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
    });
  },

  DownloadTxtFile(controller, params, fileName = 'arquivo.txt') {
    return downloadFile(controller, params, {
      defaultFileName: fileName,
      extension: '.txt',
      contentType: 'text/plain;charset=utf-8'
    });
  },

  DownloadJsonFile(controller, params, fileName = 'arquivo.json') {
    return downloadFile(controller, params, {
      defaultFileName: fileName,
      extension: '.json',
      contentType: 'application/json'
    });
  },

  DownloadZipFile(controller, params, fileName = 'arquivo.zip') {
    return downloadFile(controller, params, {
      defaultFileName: fileName,
      extension: '.zip',
      contentType: 'application/zip'
    });
  },

  DownloadXmlFile(controller, params, fileName = 'arquivo.xml') {
    return downloadFile(controller, params, {
      defaultFileName: fileName,
      extension: '.xml',
      contentType: 'application/xml'
    });
  },

  DownloadCsvFile(controller, params, fileName = 'arquivo.csv') {
    return downloadFile(controller, params, {
      defaultFileName: fileName,
      extension: '.csv',
      contentType: 'text/csv;charset=utf-8'
    });
  }
};

const api = {
  ...util,
  Axios: axios,
  controller: 'UTIL'
};

export default api;